"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const moment_1 = __importDefault(require("moment"));
const __1 = require("../..");
exports.StaticField = ({ value, title, type, inline, labelSize, labelPosition = "left", labelClassName, tooltip, tooltipColor, labelAlign = "right", }) => {
    function parsePercent(val) {
        if (val === "NaN" || val === "" || val === undefined)
            val = "0,00";
        if (typeof val === "string")
            return `% ${parseFloat(val).toLocaleString("pt-br", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}`;
        else
            return `% ${val.toLocaleString("pt-br", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}`;
    }
    function parseMoney(val) {
        if (val === "NaN" || val === "")
            val = "0,00";
        if (typeof val === "string")
            return `R$ ${parseFloat(val).toLocaleString("pt-br", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}`;
        else
            return `R$ ${val.toLocaleString("pt-br", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}`;
    }
    function parseDate(val) {
        return moment_1.default(val).format("DD/MM/YYYY");
    }
    function parseValue() {
        var formattedValue = "";
        if (value && value !== "")
            formattedValue = value;
        if (type === "date")
            return parseDate(formattedValue);
        else if (type === "money")
            return parseMoney(formattedValue);
        else if (type === "percent")
            return parsePercent(formattedValue);
        return formattedValue;
    }
    function renderField() {
        let value = parseValue();
        const labelClasses = classnames_1.default({
            col: title,
            "form-control-plaintext": title,
            "ml-1": labelPosition === 'left',
        });
        return react_1.default.createElement("label", { className: labelClasses }, value);
    }
    const containerClassName = classnames_1.default("form-group", {
        "col-md": inline,
    });
    if (labelPosition === 'up') {
        return (react_1.default.createElement("div", { className: containerClassName },
            title && (react_1.default.createElement(__1.Label, { value: title, size: labelSize, labelPosition: labelPosition, className: labelClassName, tooltip: tooltip, tooltipColor: tooltipColor, labelAlign: labelAlign })),
            renderField()));
    }
    if (title) {
        return (react_1.default.createElement("div", { className: containerClassName },
            react_1.default.createElement(__1.Row, null,
                title && (react_1.default.createElement(__1.Label, { value: title, size: labelSize, labelPosition: labelPosition, className: labelClassName, tooltip: tooltip, tooltipColor: tooltipColor, labelAlign: labelAlign })),
                react_1.default.createElement("div", { className: "col" }, renderField()))));
    }
    return renderField();
};
